export class SmsTemplate {
  public id: number;
  public name: string;
  public message: string;
  public messageEn: string;
  public messageEs: string;
  public messageIt: string;
  public messageFr: string;
  public createDate: Date;
  public lastModifiedDate: Date;
}
